// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@keyframes spinner {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
  .loading-spinner {
    width: 25px;
    height: 25px;
    border: 3px solid #f3f3f3; /* Light grey */
    border-top: 3px solid  #8B0000; /* Black */
    border-radius: 50%;
    animation: spinner 1.5s linear infinite;
  }`, "",{"version":3,"sources":["webpack://./src/app/components/Loader/Spinner.css"],"names":[],"mappings":"AAAA;IACI;MACE,uBAAuB;IACzB;IACA;MACE,yBAAyB;IAC3B;EACF;EACA;IACE,WAAW;IACX,YAAY;IACZ,yBAAyB,EAAE,eAAe;IAC1C,8BAA8B,EAAE,UAAU;IAC1C,kBAAkB;IAClB,uCAAuC;EACzC","sourcesContent":["@keyframes spinner {\n    0% {\n      transform: rotate(0deg);\n    }\n    100% {\n      transform: rotate(360deg);\n    }\n  }\n  .loading-spinner {\n    width: 25px;\n    height: 25px;\n    border: 3px solid #f3f3f3; /* Light grey */\n    border-top: 3px solid  #8B0000; /* Black */\n    border-radius: 50%;\n    animation: spinner 1.5s linear infinite;\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
